<div id="wrapper" #main>
  <div *ngIf="false">
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile" ></app-menu>
  </div>
  <div style="margin-bottom: 0px;" style="display: none;"  *ngIf="false">

    <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
                 (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
                 (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
                 (updateInitializeData)="this.initializeData()"></app-tab-nav>
  </div>
  <app-add-product *ngIf="false" ></app-add-product>
  <div class="allcont logsize">
    <app-payment-component [dataPay]="this.paymentData" *ngIf="this.paymentscreen==1"
                           (updatescreenview)="this.screenActual=$event" (updateNroOrder)="this.nroOrder=$event"
                           (updatepaymentview)="this.paymentscreen=$event">
    </app-payment-component>
    <div class="basicrow" *ngIf="this.paymentscreen!=1">
      <div class="container">
        <div class="basicr-line-i c-m-t">
          <div class="fulltitle f-btitle autodef">
            <span class="icon-dash-05"></span> Cambio de Plan
          </div>
          <div class="pull-right" *ngIf="this.postpago==true||this.telefoniaFijo==true"> 
            <!---
            <label class="label-r sidenmbr vcenter w-auto">
                            <span class="tabcell">
                                N&uacute;mero de Cuenta
                            </span>
            </label>
            <div class="autorow subsc  mob-wid pull-right">
              <div *ngIf="this.totalAccountList > 0">
                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"
                        style="background-image:url(/assets/images/selectabarrw.png)">
                  <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                    {{list.account}}</option>
                </select>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow" *ngIf="(this.postpago==true || this.telefoniaFijo==true)&&this.paymentscreen!=1">
      <div id="currentplan" class="basicrow m-top-ii">
        <div class="basicrow mbott-i">
          <div class="container" *ngIf="this.screenActual==1">
            <div class="letrero-gen">
              <div
                class="basicrow mbott bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify letrero">
                Selecciona el
                <span class="roboto-b">número de cuenta y número de suscriptor</span> a la que deseas
                aplicar el cambio.
              </div>
            </div>
            <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
              <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i"
                   class="digs-box-f vcenter mob-txt" (click)="updateExpand(i)"
                   [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                <div *ngIf="inf.productTypeField=='G'">
                  <span class="roboto-l">M&Oacute;VIL </span>
                  <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                  <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                  <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                </div>
                <div *ngIf="inf.productTypeField=='O'">
                  <span class="roboto-l">TELEFONÍA FIJA </span>
                  <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                  <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                  <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                </div>
              </div>
              <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                  <app-currentplan-changeplan [index]="i"
                                              [currentPlan]="inf.planInfoField.sOCDescriptionField"
                                              [quota_val]="inf.equipmentInfoField.installmentValueField"
                                              [actualPrice]="inf.planInfoField.socRateField"
                                              [plan_desc]="inf.planInfoField.sOCDescriptionInfoField"
                                              [plac_eq]="inf.equipmentInfoField"
                                              [add_serv]="inf.servSVAInfoField.servSVAsField"
                                              [equ_instal]="inf.equipmentInfoField.installmentsField"
                                              [desc_equ]="inf.equipmentInfoField.itemDescriptionField"
                                              [plan_type]="this.type">
                  </app-currentplan-changeplan>
                  <div class="autocont f-black roboto-l f-bmed pull-left vcenter box-plan">
                    <div class="f-big m-top-i"  *ngIf="offers.length > 0">
                      Planes Sugeridos
                    </div>
                    <div class="basicrow m-top-ii">
                      <div class="logline full"></div>
                    </div>
                    <div 
                    >
                      <app-packages-carousel [index]="i" [offers]="this.offers"
                      [commitmentOriginalMonths]="inf.planInfoField.mCommitmentOrigNoMonthField"
                      [currentPlan]="inf.planInfoField.sOCDescriptionField"
                      [actualPrice]="inf.planInfoField.socRateField"
                      [productType]="inf.productTypeField"
                      [currentplanId]="inf.planInfoField.sOCInfoField"
                      [subscriber]="inf.subscriberNumberField" [textoMovil]="this.textoMovil"
                      [nextDate]="this.nextDate" [numberOrder]="this.numberOrder"
                      (updateId)="this.id=$event"
                      (updateCurrentPlan)="this.currentPlan=$event"
                      (updateActualPrice)="this.actualPrice=$event"
                      (updatePlanToChange)="this.planToChange=$event"
                      (updateDescriptions)="this.descriptions=$event"
                      (updatePricePlan)="this.pricePlan=$event"
                      (checkTextMobile)="this.textoMovil=$event"
                      (viewNextDate)="this.nextDate=$event"
                      (checkContract)="this.commitmentOriginalMonths=$event"
                      (validateType)="this.actualType=$event" (viewNextSoc)="this.nextSoc=$event"
                      (viewActualSoc)="this.currentSoc=$event"
                      (viewSubscriberNumber)="this.subscriber=$event"
                      (viewNumberOrder)="this.numberOrder=$event"
                      [total_rate]="inf.planInfoField.totalRateField"
                      [prod_type]="inf.productTypeField" [sub_num]="inf.subscriberNumberField"
                      [info_soc]="this.info[i].planInfoField.sOCInfoField"
                      [balance]="0"
                      [type]="'postpaidORfixed'"
                      (updatescreenview)="this.screenActual=$event">
</app-packages-carousel>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" *ngIf="this.screenActual==2">
            <app-selected-plan (updatepayment)="this.paymentData=$event"
                               (updatepaymentview)="this.paymentscreen=$event" [currentPlan]="this.currentPlan"
                               [actualPrice]="this.actualPrice" [planToChange]="this.planToChange"
                               [descriptions]="this.descriptions" [pricePlan]="this.pricePlan"
                               [nextDate]="this.nextDate"
                               [textoMovil]="this.textoMovil" [actualType]="this.actualType"
                               [currentSoc]="this.currentSoc"
                               [nextSoc]="this.nextSoc" [subscriberNumber]="this.subscriber"
                               [commitmentOriginalMonths]="this.commitmentOriginalMonths" [selectBan]="this.selectBan"
                               (updateNroOrder)="this.nroOrder=$event" (updateNumberOrder)="this.numberOrder=$event"
                               (updatescreenview)="this.screenActual=$event"
                               (updateinitializeData)="this.initializeData()">
            </app-selected-plan>
          </div>
          <div class="container" *ngIf="this.screenActual==3">
            <app-plan-change-confirmation [nroOrder]="this.nroOrder" [pricePlan]="this.pricePlan"
                                          [planToChange]="this.planToChange" [descriptions]="this.descriptions"
                                          [numberOrder]="this.numberOrder" (updatescreenview)="this.screenActual=$event"
                                          (updateInitializeData)="this.initializeData()">
            </app-plan-change-confirmation>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow" *ngIf="this.prepago==true">
      <div id="currentplan" class="basicrow m-top-ii">
        <div class="basicrow mbott-i">
          <div class="container" *ngIf="this.screenActual==1">
            <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
              <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                   (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                <div *ngIf="inf.productTypeField=='G'">
                  <span class="roboto-l">M&Oacute;VIL </span>
                  <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                  <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                  <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                </div>
              </div>
              <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                  <div class="panel">
                    <div class="panel-header">
                      Cambio de Plan
                    </div>
                    <div class="panel-body" *ngIf="tabSelected === 1">
                      <app-changeplan-prepaid [index]="i"
                                              [plan]="inf.planInfoField.sOCDescriptionField"
                                              [soc_des]="inf.planInfoField.sOCDescriptionInfoField"
                                              [act_date]="inf.planInfoField.effectiveDateField"
                                              [actualPrice]="inf.planInfoField.socRateField">
                      </app-changeplan-prepaid>
                      <app-packages-carousel
                        [index]="i"
                        [offers]="this.offers"
                        [commitmentOriginalMonths]="inf.planInfoField.mCommitmentOrigNoMonthField"
                        [currentPlan]="inf.planInfoField.sOCDescriptionField"
                        [actualPrice]="inf.planInfoField.socRateField"
                        [productType]="inf.productTypeField"
                        [currentplanId]="inf.planInfoField.sOCInfoField"
                        [subscriber]="inf.subscriberNumberField" [textoMovil]="this.textoMovil"
                        [nextDate]="this.nextDate" [numberOrder]="this.numberOrder"
                        (updateId)="this.id=$event"
                        (updateCurrentPlan)="this.currentPlan=$event"
                        (updateActualPrice)="this.actualPrice=$event"
                        (updatePlanToChange)="this.planToChange=$event"
                        (updateDescriptions)="this.descriptions=$event"
                        (updatePricePlan)="this.pricePlan=$event"
                        (checkTextMobile)="this.textoMovil=$event"
                        (viewNextDate)="this.nextDate=$event"
                        (checkContract)="this.commitmentOriginalMonths=$event"
                        (validateType)="this.actualType=$event" (viewNextSoc)="this.nextSoc=$event"
                        (viewActualSoc)="this.currentSoc=$event"
                        (viewSubscriberNumber)="this.subscriber=$event"
                        (viewNumberOrder)="this.numberOrder=$event"
                        [total_rate]="inf.planInfoField.totalRateField"
                        [prod_type]="inf.productTypeField" [sub_num]="inf.subscriberNumberField"
                        [info_soc]="this.info[i].planInfoField.sOCInfoField"
                        [balance]="stringToNumber(this.info[i].prepaidBalanceField)"
                        [type]="'prepaid'"
                        (updatescreenview)="this.tabSelected=$event">
                      </app-packages-carousel>
                    </div>
                  </div>
                  <div class="panel">
                    <div class="panel-header">
                      Recarga de Saldo
                    </div>
                    <div class="panel-body" *ngIf="tabSelected === 2">
                      <app-selected-plan-prepaid
                        (updatepayment)="this.paymentData=$event"
                        (updatepaymentview)="this.paymentscreen=$event"
                        [id]="this.id"
                        [validatePaymentGreaterThanBalance]="validatePaymentGreaterThanBalance(inf)"
                        [currentPlan]="this.currentPlan"
                        [actualPrice]="this.actualPrice"
                        [planToChange]="this.planToChange"
                        [descriptions]="this.descriptions"
                        [pricePlan]="this.pricePlan"
                        [nextDate]="this.nextDate"
                        [textoMovil]="this.textoMovil"
                        [actualType]="this.actualType"
                        [currentSoc]="this.currentSoc"
                        [nextSoc]="this.nextSoc"
                        [accounInfo]="this.accounInfo"
                        [subscriberNumber]="this.subscriber"
                        [commitmentOriginalMonths]="this.commitmentOriginalMonths" [selectBan]="this.selectBan"
                        (updateNroOrder)="this.nroOrder=$event" (updateNumberOrder)="this.numberOrder=$event"
                        (updatescreenview)="this.tabSelected=$event"
                        (updateinitializeData)="this.initializeData()"
                      >
                      </app-selected-plan-prepaid>
                      <app-recharge-diff-plan
                        [id]="this.id"
                        [validatePaymentGreaterThanBalance]="validatePaymentGreaterThanBalance(inf)"
                        [currentPlan]="this.currentPlan"
                        [actualPrice]="this.actualPrice"
                        [planToChange]="this.planToChange"
                        [descriptions]="this.descriptions"
                        [pricePlan]="this.pricePlan"
                        [actualType]="this.actualType"
                        [currentSoc]="this.currentSoc"
                        [nextSoc]="this.nextSoc"
                        [accounInfo]="this.accounInfo"
                        [subscriberNumber]="this.subscriber"
                        (updateNroOrder)="this.nroOrder=$event"
                        (updateinitializeData)="this.initializeData()"
                        [currentBalance]="stringToNumber(inf.prepaidBalanceField)"
                        [balanceToRecharge]="getValuetoRecharge(this.pricePlan,inf.prepaidBalanceField)"
                        (updateScreenView)="this.tabSelected=$event"
                        (updatePaymentSuccessValue)="this.validatePaymentSuccess=$event"
                      >
                      </app-recharge-diff-plan>
                    </div>
                    <app-recharge-response
                      [condition]="tabSelected === 2.5"
                      [valueRecharged]="getValuetoRecharge(this.pricePlan,inf.prepaidBalanceField)"
                      [phoneNumber]="inf.subscriberNumberField"
                      (updateScreenView)="tabSelected=$event"
                      [validatePaymentSuccess]="validatePaymentSuccess"
                      [id]="this.id"
                      [token]="this.token"
                      [actualType]="this.typeActual"
                      [currentSoc]="this.currentSoc"
                      [nextSoc]="this.nextSoc"
                      [accounInfo]="this.accounInfo"
                      (updateinitializeData)="this.initializeData()"
                    >
                    </app-recharge-response>
                  </div>
                  <div class="panel">
                    <div class="panel-header">
                      Confirmación
                    </div>
                    <div class="panel-body" *ngIf="tabSelected === 3">
                      <app-plan-change-confirmation [nroOrder]="this.nroOrder"
                                                    [pricePlan]="this.pricePlan"
                                                    [planToChange]="this.planToChange"
                                                    [descriptions]="this.descriptions"
                                                    [numberOrder]="this.numberOrder"
                                                    (updatescreenview)="this.screenActual=$event"
                                                    (updateInitializeData)="this.initializeData()">
                      </app-plan-change-confirmation>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="basicrow m-top-i text-center roboto-b f-black">
              Para cualquier tarifa que no se encuentre aqu&iacute; puede comunicarse con nuestro personal
              de servicio en <a routerLink="/changeplan" (click)="this.goChat()" class="linkdefs">el
              Chat</a>
            </div>
          </div>
          <div class="container" *ngIf="this.screenActual==2">
            <app-selected-plan-prepaid
              (updatepayment)="this.paymentData=$event"
              (updatepaymentview)="this.paymentscreen=$event"
              [id]="this.id"
              [currentPlan]="this.currentPlan"
              [actualPrice]="this.actualPrice"
              [planToChange]="this.planToChange"
              [descriptions]="this.descriptions"
              [pricePlan]="this.pricePlan"
              [nextDate]="this.nextDate"
              [textoMovil]="this.textoMovil"
              [actualType]="this.actualType"
              [currentSoc]="this.currentSoc"
              [nextSoc]="this.nextSoc"
              [accounInfo]="this.accounInfo"
              [subscriberNumber]="this.subscriber"
              [commitmentOriginalMonths]="this.commitmentOriginalMonths" [selectBan]="this.selectBan"
              (updateNroOrder)="this.nroOrder=$event" (updateNumberOrder)="this.numberOrder=$event"
              (updatescreenview)="this.screenActual=$event"
              (updateinitializeData)="this.initializeData()">
            </app-selected-plan-prepaid>
          </div>
          <div class="container" *ngIf="this.screenActual==3">
            <app-plan-change-confirmation [nroOrder]="this.nroOrder"
                                          [pricePlan]="this.pricePlan"
                                          [planToChange]="this.planToChange" [descriptions]="this.descriptions"
                                          [numberOrder]="this.numberOrder"
                                          (updatescreenview)="this.screenActual=$event"
                                          (updateInitializeData)="this.initializeData()">
            </app-plan-change-confirmation>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-footer *ngIf="!global.isIframe"></app-footer>
</div>
